import { handleAction } from 'redux-actions';

import * as actions from '../actions';

const InitialState = '';

export const tokenReducer = handleAction(
  actions.setToken,
  (state, { payload: token }) => token,
  InitialState
);
